import cn from "classnames";
import React, { FC } from "react";

import P from "@/apps/ui/components/P";

import style from "./style.css";

type ListItemProps = {
  code: string;
  description: string;
  descriptionDetailed: string;
  status: boolean;
};

const ListItem: FC<ListItemProps> = function ({ description, status }) {
  return (
    <div className={style.item}>
      <div className={style.info}>{description && <P className={style.description}>{description}.</P>}</div>
      <div className={cn(style.status, style[`status-${status}`])}>
        {status ? "Кампания пройдена." : "Кампания проводится, свяжитесь с официальным дилером Suzuki."}
      </div>
      {/* <div className={styleCss.action}>
        <Button>Записаться на сервис</Button>
      </div> */}
    </div>
  );
};

export default ListItem;
